import React from "react";
import notify from "devextreme/ui/notify";
import Form, {
  SimpleItem,
  GroupItem,
  Label,
  EmptyItem,
} from "devextreme-react/form";
import { Button } from "devextreme-react";
import "devextreme-react/text-area";
import UserInfo from "../../UserInfo";
import {
  criarCndDs,
  criarConfiguracaoCndDs,
  criarContribuinteDs,
  criarImovelDs,
  criarCpbsDs,
} from "../../DataSources";
import ShowError from "../../AppServices";

const template = {
  id: undefined,
  prefeituraId: undefined,
  contribuinteId: undefined,
  imovelId: undefined,
  cpbsId: undefined,
  tipoDeCertidaoId: undefined,
  ano: undefined,
  numero: undefined,
  data: new Date(),
  tipoCadastro: "C",
  validade: undefined,
  obs: "",
  popupVisivel: false,
};

export default class VisualizarCertidao extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    template.prefeituraId = UserInfo.getPrefeitura();
    this.cndDs = criarCndDs();
    this.contribuinteDs = criarContribuinteDs();
    this.imovelDs = criarImovelDs();
    this.cpbsDs = criarCpbsDs();

    this.verPdf = this.verPdf.bind(this);
    this.cancel = this.cancel.bind(this);
    this.saidaProgramada = false;

    this.tipoDeCertidaoOptions = {
      searchEnabled: true,
      placeholder: "Selecione...",
      dataSource: criarConfiguracaoCndDs(),
      valueExpr: "id",
      displayExpr: "descricao",
      readOnly: true,
    };
  }

  componentDidMount() {
    if (this.props.match.params.id !== undefined) {
      this.cndDs
        .byKey(this.props.match.params.id)
        .then((data) => {
          if (data === undefined) {
            notify("CND não encontrado.", "error");
            this.props.history.push("/certidaonegativa");
          }
          this.setState(data);
        })
        .catch((error) => {
          ShowError(error.response.data);
          notify(error, "error", 2000);
          this.props.history.goBack();
        });
    }
  }

  render() {
    return (
      <React.Fragment>
        <div className={"content-block dx-card responsive-paddings"}>
          <Form formData={this.state} colCount={2}>
            <GroupItem caption="CERTIDÃO NEGATIVA" colSpan={2} colCount={4}>
              <SimpleItem
                dataField={"tipoDeCertidaoId"}
                editorType={"dxLookup"}
                editorOptions={this.tipoDeCertidaoOptions}
                colSpan={4}
              >
                <Label text="Tipo de Certidão" />
              </SimpleItem>
              <SimpleItem
                dataField={"id"}
                editorOptions={{ readOnly: true }}
                colSpan={1}
              >
                <Label text="ID" />
              </SimpleItem>
              <EmptyItem colSpan={3} />
              <SimpleItem dataField={"ano"} colSpan={1} editorOptions={{ readOnly: true }}>
                <Label text="Ano" />
              </SimpleItem>
              <SimpleItem dataField={"numero"} colSpan={1} editorOptions={{ readOnly: true }}>
                <Label text="Número" />
              </SimpleItem>
              <EmptyItem colSpan={2} />
              <SimpleItem
                dataField={"data"}
                colSpan={1}
                editorType="dxDateBox"
                editorOptions={{ width: "100%", readOnly: true }}
              >
                <Label text="Data" />
              </SimpleItem>
              <SimpleItem dataField={"validade"} colSpan={1} editorOptions={{ readOnly: true }}>
                <Label text="Validade" />
              </SimpleItem>
              <EmptyItem colSpan={2} />
              <SimpleItem
                dataField={"obs"}
                colSpan={4}
                editorType={"dxTextBox"}
                editorOptions={{ height: "120px", readOnly: true }}
              >
                <Label text="Observação" />
              </SimpleItem>
            </GroupItem>
          </Form>
          <div
            style={{
              display: "flex",
              marginTop: "25px",
              justifyContent: "center",
              alignContent: "center",
              justifyItems: "center",
              alignItems: "center",
            }}
          >
            <div style={{ display: "inline-block" }}>
              <Button
                width={120}
                text="Visualizar PDF"
                type="success"
                onClick={this.verPdf}
              />
            </div>
            <div style={{ marginLeft: "10px" }}>
              <Button
                width={120}
                text="Cancelar"
                type="danger"
                onClick={this.cancel}
              />
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }

  verPdf() {
      alert("PDF visto");
  }

  cancel() {
    this.props.history.goBack();
  }
}
